<template>
    <div style="background-color: white;" v-if="lc_data!=null">
        <br>
        <div class="cardbody">
            <v-row>
                <div class="row">
                    <div class="col-3">
                        <img :src="org_basic_data.trust_logo" alt="" class="schlImg" />
                    </div>
                    <div class="col-9">
                        <center>
                            <h4 class="trust-name">
                                {{org_basic_data.trust_name}}
                            </h4>
                        </center>
                        <center>
                            {{org_basic_data.address}}
                        </center>
                        <center>
                            {{org_basic_data.phone}}
                        </center>
                        <center><strong>UDISE Code:</strong> {{lc_data.udise_no}}</center>
                        <center><strong>ICSE School Code:</strong> {{org_basic_data.school_no}}</center>
                    </div>
                </div>
            </v-row>
        
            <v-row>
                <!-- <span style="margin-left: 20px;">Student's Gen. Reg. No:</span>
                <span class="stud_details">{{lc_data.reg_number}}</span>
                <span style="margin-left: 250px;">Sr.No:</span>
                <span>{{lc_data.certificate_no}}</span> -->
                <div class="row">
                        <div class="col-6 mt-5" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>Student's Gen. Reg. No: </b>
                                <div style="width: 38%; margin-left: 5px;" class="stud_details2">{{lc_data.reg_number}}</div>
                            </div>
                        </div>
                        <div class="col-6 mt-5" style="">
                            <div class="row" style="margin-left: 120px;">
                                <b>Sr.No:</b>
                              {{lc_data.certificate_no}}
                            </div>
                        </div>
                        </div>
                <v-col cols="12" sm="12" md="12">
                    <!-- <hr class="hr-tag" />
                    <br />
                    <hr class="hr-tag" /> -->
                    <div style="width: 98%; margin-left: 10px;" class="stud_details2"></div><br>
                    <div style="width: 98%; margin-left: 10px;" class="stud_details2"></div>
                    <span style="margin-left: 20px;"><b>Student Id:</b> {{ lc_data.gr_number }}</span>
                    <span style="margin-left: 250px;"><b>UID Aadhar No.:</b> {{ lc_data.aadhar_no }}</span>
                    <!-- <hr class="hr-tag" /> -->
                    <div style="width: 98%; margin-left: 10px;" class="stud_details2"></div>
                    <div class="row">
                        <div class="col-6 mt-5" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>Name Of Pupil in Full:</b><b>(Name) </b>
                                <div style="width: 38%; margin-left: 5px;" class="stud_details2">{{lc_data.first_name}}</div>
                            </div>
                        </div>
                        <div class="col-6 mt-5" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>(Father's Name):</b>
                                <div style="width: 60.5%; margin-left: 5px;" class="stud_details2">{{lc_data.middle_name}}</div>
                            </div>
                        </div>
                        <div class="col-12" style="">
                            <div class="row" style="margin-left: 160px;">
                                <b>(Surname)</b>
                                <div style="width: 83.5%; margin-left: 5px;" class="stud_details2">{{lc_data.last_name}}</div>
                            </div>
                        </div>
                        <div class="col-12" style="">
                            <div class="row" style="margin-left: 25px;">
                                <b>Mother's Name:</b>
                                <div style="width: 81.5%; margin-left: 5px;" class="stud_details2">{{lc_data.mother_first_name}}</div>
                            </div>
                        </div>
                        <div class="col-6" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>Nationality: </b>
                                <div style="width: 72%; margin-left: 5px;" class="stud_details2">{{ lc_data.nationality }}</div>
                            </div>
                        </div>
                        <div class="col-6" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>Mother Tongue: </b>
                                <div style="width: 61%; margin-left: 5px;" class="stud_details2">{{ lc_data.mothertoungue }}</div>
                            </div>
                        </div>
                        <div class="col-4" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>Religion: </b>
                                <div style="width: 69%; margin-left: 5px;" class="stud_details2">{{ lc_data.religion }}</div>
                            </div>
                        </div>
                        <div class="col-4" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>Cast: </b>
                                <div style="width: 80%; margin-left: 5px;" class="stud_details2">{{ lc_data.caste }}</div>
                            </div>
                        </div>
                        <div class="col-4" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>Subcast: </b>
                                <div style="width: 62.5%; margin-left: 5px;" class="stud_details2">{{ lc_data.subcaste }}</div>
                            </div>
                        </div>
                        <div class="col-3" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>Place Of Birth: </b>
                                <div style="width: 31%; margin-left: 5px;" class="stud_details2">{{ lc_data.birth_place }}</div>
                            </div>
                        </div>
                        <div class="col-2" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>Tal: </b>
                                <div style="width: 67%; margin-left: 5px;" class="stud_details2">{{ lc_data.birth_taluka }}</div>
                            </div>
                        </div>
                        <div class="col-2" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>Dist: </b>
                                <div style="width: 60%; margin-left: 5px;" class="stud_details2">{{ lc_data.birth_district }}</div>
                            </div>
                        </div>
                        <div class="col-2" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>State: </b>
                                <div style="width: 50%; margin-left: 5px;" class="stud_details2">{{ lc_data.birth_state }}</div>
                            </div>
                        </div>
                        <div class="col-3" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>Country: </b>
                                <div style="width: 49%; margin-left: 5px;" class="stud_details2">{{ lc_data.birth_country }}</div>
                            </div>
                        </div>
                        <div class="col-12" style="">
                        <div class="row" style="margin-left: 20px;">
                                <b>Date of Birth (in figure):</b>
                                <span style="margin-left: 20px;"> {{ lc_data.dob_fig }}</span>
                            </div>
                        </div>
                        <div class="col-12" style="">
                        <div class="row" style="margin-left: 20px;">
                                <b>Date of Birth (in words):</b>
                                <div style="width: 74%; margin-left: 5px;" class="stud_details2">{{ lc_data.dob_words }}</div>
                            </div>
                        </div>
                        <div class="col-12" style="">
                        <div class="row" style="margin-left: 20px;">
                                <b>Last School Attended:</b>
                                <div style="width: 75.5%; margin-left: 5px;" class="stud_details2">{{ lc_data.last_school }}</div>
                            </div>
                        </div>
                        <div class="col-6" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b> Date of Admission: </b>
                                <div style="width: 59%; margin-left: 5px;" class="stud_details2"> {{lc_data.doa}}</div>
                            </div>
                        </div>
                        <div class="col-6" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>Class: </b>
                                <div style="width: 82%; margin-left: 5px;" class="stud_details2">{{lc_data.admittedstandard}}</div>
                            </div>
                        </div>
                        <div class="col-6" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b> Progress: </b>
                                <div style="width: 78%; margin-left: 5px;" class="stud_details2"> {{lc_data.progress}}</div>
                            </div>
                        </div>
                        <div class="col-6" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>Conduct: </b>
                                <div style="width: 76%; margin-left: 5px;" class="stud_details2">{{lc_data.conduct}}</div>
                            </div>
                        </div>
                        <div class="col-12" style="">
                        <div class="row" style="margin-left: 20px;">
                                <b>Date Of Leaving School:</b>
                                <span style="margin-left: 20px;"> {{ lc_data.last_date_of_school }}</span>
                            </div>
                        </div>
                        <div class="col-12" style="">
                        <div class="row" style="margin-left: 20px;">
                                <b>Standard in which studying and since when(in figures):</b>
                                <div style="width: 44%; margin-left: 5px;" class="stud_details2">  {{ lc_data.standard }} and {{ lc_data.standard_since_when }}</div>
                            </div>
                        </div>
                        <div class="col-12" style="">
                        <div class="row" style="margin-left: 20px;">
                                <b>Reason of Leaving School:</b>
                                <div style="width: 71.5%; margin-left: 5px;" class="stud_details2">  {{ lc_data.reason }}</div>
                            </div>
                        </div>
                        <div class="col-12" style="">
                        <div class="row" style="margin-left: 20px;">
                                <b>Remark:</b>
                                <div style="width: 90%; margin-left: 5px;" class="stud_details2">  {{ lc_data.remark }}</div>
                            </div>
                        </div>
                        <span class="b2-span" style="margin-left: 10%;">Certified that the above information is in accordance with School General Register. </span><br />
                    </div>
                    <br>
                     <div class="row">
                        <div class="col-4" style="">
                            <div class="row" style="margin-left: 20px;">
                                <b>Dated: </b>
                                
                            </div>
                        </div>
                        <div class="col-4" style="">
                            <div class="row" style="margin-left: 20px;">
                              <center><b> Month: </b></center>  
                            </div>
                        </div>
                        <div class="col-4" style="">
                            <div class="row" style="margin-left: 20px;">
                              <center> <b> Year: </b></center> 
                            </div>
                        </div>
                    </div> 
                   <br><br>
            <div class="row">
                    <div class="col-3 ml-3">
                        <span><b>Class Teacher</b></span>
                    </div>
                    <div class="col-4">
                      <center><span><b>Clerk</b></span></center>  
                    </div>
                    <div class="col-4">
                       <center><span><b>Headmistress Sign</b></span></center> 
                    </div>
                </div>
            <div class="row" style="line-height: 1.2rem;">
            <div class="col-1 ml-none" style="margin-left: 20px;">Note:</div>
            <div class="col-10">
                <span>1) Any changes in school leaving certificate should carried out in red ink with the initiation of the Headmistress</span>
                <br />
                <span>2) Any infringenment of this rule is liable to rustication or other suitable punishment.</span>
            </div>
        </div>
                </v-col>
            </v-row>
            
        </div>
      
    </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
    import moment from "moment";
    export default {
      data() {
            return {
                lc_data: null,
                org_basic_data: null,
                last_date_of_school: "",
            }
      },
       mounted() {
            this.lc_data = JSON.parse(localStorage.getItem("lc_data"));
            if(this.lc_data.last_date_of_school){
            this.lc_data.last_date_of_school = moment(this.lc_data.last_date_of_school).format("DD/MM/YYYY");
            }
            if(this.lc_data.dob_fig){
            this.lc_data.dob_fig = moment(this.lc_data.dob_fig).format("DD/MM/YYYY");
            }
            if(this.lc_data.doa){
            this.lc_data.doa = moment(this.lc_data.doa).format("DD/MM/YYYY");
            }
            // console.log(this.lc_data)
            this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
            this.last_date_of_school = localStorage.getItem("last_date_of_school");
        },
    };
</script>
<style scoped>
    .cardbody {
        width: 750px;
        display: inline-block;
        background-color: white;
        height: auto;
    }

    .schlImg {
        width: 84%;
        /* height: 60%; */
        margin-left: 10%;
    }
    .lcheading1 {
        /* margin-left: 16%; */
        width: 64%;
        border-radius: 17px;
        border: 1px solid black;
    }
    .hr-tag {
        height: 1px;
        border-width: 0px;
        color: black;
        background-color: black;
        width: 100%;
        /* margin-left: -12px; */
        margin-bottom: 4px;
    }
    .lcheading2 {
        margin-left: 37%;
        width: 42%;
        border-radius: 6px;
        margin-top: 3px;
        border: 1px solid black;
        text-transform: uppercase;
    }
    .hr-tag2 {
        height: 1px;
        border-width: 0px;
        color: black;
        background-color: black;
        width: 100%;
    }
    .dotted-underline {
        border-bottom: 1px dashed;
        /* line-height: 1.2rem; */
    }
    .school-info {
        line-height: 0.3rem;
    }
    .stud-info {
        line-height: 0.5rem;
    }

    @media print {
        .schlImg {
            width: 84%;
        }

        @page {
            size: A4;
            margin-top: 20px;
            padding-top: 10px;
            /* size: 11.5in 17.5in; */

            size: 210mm 297mm;
            /* size: 10in 18in; */

            /* size: 10in 17in; */
        }
    }
    .stud_details2 {
      border-bottom: 1px solid black;
  }
  .hr-tag {
      height: 1px;
      border-width: 0px;
      color: black;
      background-color: black;
      width: 98%;
      margin-left: 10px;
      margin-bottom: 4px;
  }
  div.row{
    margin-top: -10px;
  }
  .trust-name {
      /* margin-left: 22%; */
      text-transform: uppercase;
      font-size: x-large;
  }
</style>
